const generalTypes = {
	API_STATUS: {
		LOADING: {
			START: 'API_STATUS_LOADING_START',
			STOP: 'API_STATUS_LOADING_FINISH',
		},
	},
};

export default generalTypes;
